<template>
  <div id="page-dashboard">
    <div v-if="this.$store.getters.userIsAdmin">

      {{ /* Heading page */ }}
      <div class="header-pages-block d-xl-flex justify-content-xl-between mb-xl-0">
        <h3 class="p-0">
          <b-icon class="mr-md-3" icon="bar-chart-line" font-scale="1.5" variant="primary"></b-icon> Tableau de bord
        </h3>

        <div class="mt-lg-3 mt-xl-0 p-0">
          <div class="d-flex w-100 p-2">
            <b-icon
                v-on:click="eventToggleDatePeriod"
                class="button-period mr-3 p-2"
                :class="(!toggleDatePeriod) ? '' : ''"
                icon="chevron-left"
                font-scale="2.5"
                variant="secondary"
            ></b-icon>

            <div class="text-period p-2 w-100 text-center">
              {{
                (!toggleDatePeriod)
                ? getMonthHistory().monthLessOne.dateStr
                : getMonthHistory().monthLessTwo.dateStr | capitalize
              }}
            </div>

            <b-icon
                v-on:click="eventToggleDatePeriod"
                class="button-period ml-3 p-2"
                :class="(toggleDatePeriod) ? '' : ''"
                icon="chevron-right"
                font-scale="2.5"
                variant="secondary"
            ></b-icon>
          </div>
        </div>
      </div>
      <hr/>
      <div class="d-xl-flex mt-4 mt-xl-0 mb-4">
        <div class="ml-0 mt-lg-5 mt-xl-3 col-3" v-if="dashboardList && dashboardList.length > 0">
          Nombre de commerce(s): {{ dashboardList.length }}
        </div>
        <div class="ml-0 mt-lg-5 mt-xl-3 col-3"  v-else>
          Nombre de commerce(s): {{ DashboardModule.shopsDashboard.total }}
        </div>
        <div class="filter-up-to-date d-flex col-6 justify-content-center">
          <div class="d-flex mt-1 mx-auto">
            <b-form-checkbox
                switch size="lg"
                class="mt-2"
                v-model="filter.isLate"
                v-on:change="eventChangeFilterIsLate()"
            >
              En retard
            </b-form-checkbox>
            <b-form-checkbox
                switch
                size="lg"
                class="mt-2 ml-4"
                v-model="filter.isUpToDate"
                v-on:change="eventChangeFilterIsUpToDate()"
            >
              A jour
            </b-form-checkbox>
          </div>
        </div>

        <div class="search mr-md-3 mt-4 mt-xl-2 col-3">
          <div class="input-group">
            <input type="text" class="bg-white form-control border" v-model="filter.search" placeholder="Mots-clés" v-on:keyup.enter="sendResearchRequest">
            <b-icon class="icon-x" icon="x" font-scale="1.5" v-on:click="sendResearchRequestReset"></b-icon>
            <div class="input-group-append">
              <button class="btn btn-success p-0 pl-2 pr-2" v-on:click="sendResearchRequest">
                Rechercher
              </button>
            </div>
          </div>
        </div>
      </div>
      <nav class=" mt-5 mb-3 nav nav-pills flex-column flex-sm-row text-center justify-content-center">
        <a
            class="cursor-pointer dashboard-nav-link flex-sm-fill text-sm-center nav-link m-1"
            :class="(tabs.tabCenter === 0) ? 'dashboard-nav-active bg-primary text-light' : 'btn btn-outline-success'"
            v-on:click="handleTabCenter(0)"
        >
          <div class="p-1">Tous les centres</div>
        </a>
        <a
            v-for="(center, index) in CenterModule.centers"
            class="cursor-pointer dashboard-nav-link flex-sm-fill text-sm-center nav-link m-1"
            :class="(tabs.tabCenter === center.id) ? 'dashboard-nav-active text-light bg-primary' : 'btn btn-outline-success'"

            v-on:click="handleTabCenter(center.id)"
            :key="index"
        >
          <div class="p-1">{{ center.city }}</div>
        </a>
      </nav>
      {{ /* Cards */ }}
      <div class="loader-spinner d-flex justify-content-center flex-column text-center mt-5" v-if="loader.isLoading">
        <div class="text-center">
          <b-spinner variant="success" label="Spinning"></b-spinner>
          <div class="text-primary">Chargement en cours ...</div>
        </div>
      </div>
      <div v-else>
        <Isotope
            :list="dashboardList"
            :options="isotope.options"
            class="iso-default"
        >
          <div class="mt-2" v-for="(obj, index) in dashboardList" :key="index" :class="((index + 1) === dashboardList.length) ? 'pb-3' : ''">
            <div class="card card-isotope-dashboard border-top-0 app-box-shadow" :class="(obj.isUpToDate) ? 'bg-success' : 'bg-danger'">
              <div class="badge-card-dashboard" :style="handleCssCenter(obj.shop.center.color)">
                <span class="badge-card-span-dashboard">{{ obj.shop.center.city }}</span>
              </div>
              <div class="card-body">
                <div class="text-center shop-title mb-4">
                  <router-link
                      class="text-light"
                      :to="{ name: 'shop-show', params: {'id' : obj.shop.id }, query: { isDashboard: 'true' }}">
                    <b>{{ obj.shop.name }}</b>
                  </router-link>
                </div>
                <div class="m-auto">
                  <div class="text-center small-text text-light mt-2">
                    Date limite CA: {{ obj.shop.dateLimitSale }}
                  </div>
                  <div class="text-center medium-text mt-2">
                    <a :href="'mailto:' + obj.shop.contactEmail"><span class="ml-2 text-light">{{ obj.shop.contactEmail }}</span></a>
                  </div>
                  <div v-if="obj.shop.contactPhone" class="text-center medium-text mt-2">
                    <span class="ml-2 text-light">{{ obj.shop.contactPhone }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Isotope>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      loader: {
        isLoading: false
      },
      isotope: {
        itemSelector: '.card-isotope-dashboard',
        options: {
          masonry: {
            columnWidth: 250,
            isFitWidth: true,
            gutter: 10
          }
        }
      },
      dashboardList: [],
      tabs: {
        tabCenter: 0
      },
      filter: {
        isLate: true,
        isUpToDate: true,
        search: null,
        center: null,
      },
      toggleDatePeriod: false,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      dataPage: {
        title: 'Commerces',
        dropDownName: ''
      },
      configFilter: {
        headerList : [
          {'index' : 'id', 'name' : 'ID', 'sort': 'ASC' },
          {'index' : 'id', 'name' : 'ID', 'sort': 'DESC' },
          {'index' : 'name', 'name' : 'Nom', 'sort': 'ASC' },
          {'index' : 'name', 'name' : 'Nom', 'sort': 'DESC' },
          {'index' : 'vatRate', 'name' : 'Taux de TVA', 'sort': 'ASC' },
          {'index' : 'vatRate', 'name' : 'Taux de TVA', 'sort': 'DESC' },
          {'index' : 'openDate', 'name' : 'Date d\'ouverture', 'sort': 'ASC' },
          {'index' : 'openDate', 'name' : 'Date d\'ouverture', 'sort': 'DESC' },
          {'index' : 'dateLimitSale', 'name' : 'Date limite de CA', 'sort': 'ASC' },
          {'index' : 'dateLimitSale', 'name' : 'Date limite de CA', 'sort': 'DESC' },
          {'index' : 'contactEmail', 'name' : 'Email du contact', 'sort': 'ASC'},
          {'index' : 'contactEmail', 'name' : 'Email du contact', 'sort': 'DESC'},
        ]
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
    handleTabCenter(centerId) {
      this.tabs.tabCenter = centerId
      this.filter.center = centerId
      this.dashboardList = this.filterDashboardResults()
    },
    handleCssCenter(color)
    {
      return 'background-color: ' + color
    },
    async callApiDashboard()
    {
      this.showLoader()

      let params = {
        centerId: this.filter.center,
        date: {
          month : (this.toggleDatePeriod) ? this.getMonthHistory().monthLessTwo.monthNumber : this.getMonthHistory().monthLessOne.monthNumber ,
          year: (this.toggleDatePeriod) ? this.getMonthHistory().monthLessTwo.yearNumber : this.getMonthHistory().monthLessOne.yearNumber
        }
      }

      await this.$store.dispatch('fetchDashboardShops',  params)
        .then((response) => {
            this.dashboardList = response.listDashboard

            this.hideLoader()
        })
    },
    /**
     * Toggle period
     */
    eventToggleDatePeriod()
    {
      this.toggleDatePeriod = !this.toggleDatePeriod

      this.filter.isLate = false
      this.filter.isUpToDate = false

      this.callApiDashboard()
    },
    eventChangeFilterIsLate() {
      this.dashboardList = this.filterDashboardResults()
    },
    eventChangeFilterIsUpToDate() {
      this.dashboardList = this.filterDashboardResults()
    },
    filterDashboardResults() {
        if (this.filter.isUpToDate && this.filter.isLate) {
            return this.shopsListFilteredByCenter
        }
        if (this.filter.isLate) {
          return this.getFilteredShopsList(false);
        }
        if (this.filter.isUpToDate) {
          return this.getFilteredShopsList(true);
        }
      return this.shopsListFilteredByCenter
    },
    getFilteredShopsList(itemIsUpToDate = true) {
      const shopsList = this.DashboardModule.shopsDashboard.listDashboard
      if(shopsList.length > 0) {
        return shopsList.filter(item => {
          if (this.filter.center && this.filter.center !== 0) {
            return (item.isUpToDate === itemIsUpToDate && item.shop.center.id === this.filter.center)
          } else {
            return item.isUpToDate === itemIsUpToDate;
          }
        })
      }
      return shopsList
    },
    /**
     * Reset research
     */
    sendResearchRequestReset()
    {
      this.filter.search = null
      this.dashboardList = this.DashboardModule.shopsDashboard.listDashboard
    },
    /**
     * Send request for research
     */
    sendResearchRequest()
    {
      this.dashboardList = this.searchFilterList
    },
    /**
     * Handle m-1 and m-2
     * @returns {{monthLessTwo: {dateStr: *, monthNumber: *, yearNumber: *}, monthLessOne: {dateStr: *, monthNumber: *, yearNumber: *}}}
     */
    getMonthHistory()
    {
      let currentDate = moment().format("YYYY-MM-01")

      return {
        monthLessOne : {
          dateStr: moment(currentDate).subtract(1, 'month').format('MMMM YYYY'),
          monthNumber: moment(currentDate).subtract(1, 'month').format('MM'),
          yearNumber: moment(currentDate).subtract(1, 'month').format('YYYY'),
        },
        monthLessTwo : {
          dateStr : moment(currentDate).subtract(2, 'month').format('MMMM YYYY'),
          monthNumber: moment(currentDate).subtract(2, 'month').format('MM'),
          yearNumber: moment(currentDate).subtract(2, 'month').format('YYYY'),
        }
      }
    },
  },
  async created() {
    await this.callApiDashboard()

    this.DashboardModule.shopsDashboard.listDashboard
    this.dashboardList = this.DashboardModule.shopsDashboard.listDashboard

    this.$store.dispatch('fetchCenters', {
      perPage: null,
      page: null
    })
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    searchFilterList() {
      if(this.dashboardList) {
        return this.dashboardList.filter(item => {
          return item.shop.name.match(this.filter.search.toUpperCase())
        })
      }

      return []
    },
    filterIsLate() {
      if(this.dashboardList.length > 0 && this.filter.isLate) {
        return this.dashboardList.filter(item => {
          return item.isUpToDate === false
        })
      } else {
        return this.DashboardModule.shopsDashboard.listDashboard
      }
    },
    filterIsUpToDate() {
      if(this.dashboardList.length >= 0 && this.filter.isUpToDate) {
        return this.dashboardList.filter(item => {
          return item.isUpToDate === true
        })
      } else {
        return this.DashboardModule.shopsDashboard.listDashboard
      }
    },
    shopsListFilteredByCenter() {
      if (this.filter.center) {
        return this.DashboardModule.shopsDashboard.listDashboard.filter(item => {
          return item.shop.center.id === this.filter.center
        })
      }

      return this.DashboardModule.shopsDashboard.listDashboard
    },
    ...mapState(['CenterModule']),
    ...mapState(['DashboardModule'])
  },
  components: {
    Isotope: () => import('vueisotope')
  }
}
</script>
